import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 133 141",
  style: {"enable-background":"new 0 0 133 141"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:#010101}.__st1{fill:#FFFFFF}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("g", null, [
      _createElementVNode("path", { d: "M71.1,18.4c2.1,0.3,4.2,0.5,6.3,0.9c12.5,2.2,23.1,8,31.7,17.3c7.3,7.9,12.1,17.1,14,27.6c3,16.8-0.5,32.1-11.1,45.6\n\t\tc-8.8,11.2-20.3,18.3-34.3,20.6c-20.9,3.5-38.7-2.9-52.8-18.7c-7-7.8-11.2-17-12.9-27.3c-2.8-17.8,1.7-33.7,13.7-47.2\n\t\tc8.5-9.6,19.2-15.4,31.8-17.8c1.9-0.4,3.8-0.5,5.8-0.7c0.3,0,0.7-0.1,1-0.2C66.5,18.4,68.8,18.4,71.1,18.4z M24,48\n\t\tc-0.2,0.3-0.3,0.5-0.5,0.7c-5.6,9.5-7.9,19.8-6.9,30.7c0.8,9.8,4.4,18.7,10.3,26.6c0.4,0.6,0.8,0.8,1.6,0.8c26.2,0,52.4,0,78.6,0\n\t\tc0.6,0,1-0.2,1.4-0.7c9.2-12.4,12.6-26.2,9.6-41.3c-4.4-22.1-22.2-38.4-44.5-41c-10-1.2-19.5,0.5-28.6,4.9c-2,1-4,2.2-6,3.3\n\t\tc13.6,23.6,27.2,47,40.8,70.6c-0.6,0-1,0-1.3,0c-7.2,0-14.4,0-21.6,0c-0.9,0-1.4-0.3-1.8-1C44.9,84.1,34.7,66.5,24.6,48.9\n\t\tC24.4,48.6,24.2,48.3,24,48z" }),
      _createElementVNode("path", { d: "M76.2,67.1c-2.8,0-5.4,0-8,0c0-0.1,0-0.1-0.1-0.2C78.9,60,89.6,53,100.4,46.1c2.8,7,5.5,13.9,8.3,21c-2.1,0-4.1,0.1-6,0\n\t\tc-1.8-0.2-2.7,0.5-3.6,2.1c-5.8,10.2-11.7,20.4-17.6,30.5c-0.2,0.3-0.4,0.6-0.6,1c-0.9-1.6-1.8-3-2.6-4.5\n\t\tc-2.9-5.1-5.9-10.2-8.8-15.3c-0.4-0.7-0.5-1.3,0-2c2.1-3.5,4-6.9,6.1-10.4C75.7,68,75.9,67.7,76.2,67.1z" })
    ], -1))
  ]))
}
export default { render: render }